import { render } from "./ProductQueryWrapper.vue?vue&type=template&id=b5a5b5d4"
import script from "./ProductQueryWrapper.vue?vue&type=script&lang=js"
export * from "./ProductQueryWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__